import React from 'react';
import { Auth } from 'aws-amplify';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Layout, Button } from 'antd';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import styled from '@emotion/styled';
import { ReactComponent as SparkyLogo } from '@svg/common/sparky-logo.svg';
import { scAnimSigninWave, scAnimSigninWaveSwell } from '@utils/emotion/keyframes';
import { scVarTransitionDuration } from '@utils/emotion/variables';

import { ReactComponent as People1 } from '@svg/people-1.svg';
import { ReactComponent as People2 } from '@svg/people-2.svg';
import { ReactComponent as People3 } from '@svg/people-3.svg';
import { ReactComponent as People4 } from '@svg/people-4.svg';
import { ReactComponent as People5 } from '@svg/people-5.svg';
import { useAuthStore } from '@stores/auth';

const { Content } = Layout;

const Login: React.FC = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuthStore();

  const signIn = () => {
    Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google });
  };

  if (isAuthenticated) return <Navigate replace to="/" />;

  return (
    <ContentBlock>
      <div className="signin-block">
        <div className="logo">
          <SparkyLogo />
        </div>
        <strong className="phrase">{t('login.description')}</strong>
        <div className="btn-area">
          <Button
            className="btn-signin"
            type="primary"
            size="large"
            onClick={() => {
              signIn();
            }}
          >
            {t('login.btn')}
          </Button>
        </div>
      </div>
      <div className="people-block">
        {/* <div className="people people-1" />
        <div className="people people-2" />
        <div className="people people-3" />
        <div className="people people-4" />
        <div className="people people-5" /> */}
        <People1 />
        <People2 />
        <People3 />
        <People4 />
        <People5 />
      </div>
      <div className="wave-block">
        <div className="wave" />
        <div className="wave" />
      </div>
    </ContentBlock>
  );
};

const ContentBlock = styled(Content)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.primary.bgColor};
  transition: background-color ${scVarTransitionDuration} ease;

  .logo {
    text-align: center;
  }

  .phrase {
    display: block;
    margin-top: 12px;
    text-align: center;
    font-size: 15px;
    font-weight: normal;
    line-height: 22px;
    color: ${({ theme }) => theme.colors.fontColor};
    transition: color ${scVarTransitionDuration} ease;
  }

  .btn-area {
    margin-top: 12px;
  }

  .btn-signin {
    display: block;
    width: 222px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    background-color: ${({ theme }) => theme.colors.primary.btnColor};
    border-color: ${({ theme }) => theme.colors.primary.btnColor};
    transition: background-color ${scVarTransitionDuration} ease,
      border-color ${scVarTransitionDuration} ease;
  }

  .signin-block {
    z-index: 10;
  }

  .people-block {
    display: flex;
    justify-content: space-between;
    position: fixed;
    right: 0;
    bottom: -1px;
    left: 0;
    z-index: 1;
    width: 1194px;
    margin: 0 auto;
  }

  /* .people {
    height: 280px;
    background-repeat: no-repeat;
    background-position: bottom;

    &.people-1 {
      width: 208px;
      background-image: url('/assets/svg/signin/people-1.svg');
      background-size: 208px 280px;
    }

    &.people-2 {
      width: 162px;
      background-image: url('/assets/svg/signin/people-2.svg');
      background-size: 162px 280px;
    }

    &.people-3 {
      width: 235px;
      background-image: url('/assets/svg/signin/people-3.svg');
      background-size: 235px 280px;
    }

    &.people-4 {
      width: 141px;
      background-image: url('/assets/svg/signin/people-4.svg');
      background-size: 141px 280px;
    }

    &.people-5 {
      width: 236px;
      background-image: url('/assets/svg/signin/people-5.svg');
      background-size: 236px 280px;
    }
  } */

  .wave-block {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
  }

  .wave-block .wave {
    position: absolute;
    top: -250px;
    width: 5768px;
    height: 250px;
    background-image: url('/assets/svg/signin/wave.svg');
    background-repeat: repeat-x;
    animation: ${scAnimSigninWave} 14s cubic-bezier(0.36, 0.45, 0.63, 0.53) infinite;
    transform: translate3d(0, 0, 0);

    &:nth-of-type(2) {
      top: -230px;
      animation: ${scAnimSigninWave} 14s cubic-bezier(0.36, 0.45, 0.63, 0.53) -0.5s infinite,
        ${scAnimSigninWaveSwell} 14s ease -2.5s infinite;
      opacity: 1;
    }
  }
`;

export default Login;
